// Constants for filtering
export const VERMONT_STATE_TEST_ROLENAME = 'rapidsos testing';
export const VERMONT_SJPO_ACCOUNT_ID = 'VT_SJPO';
export const SERVICE_TO_FILTER = 'Supplemental';
export const SUBLAYER_TO_FILTER = 'CARE';

/**
 * Determines if a user can see the filtered sublayer based on their account and role.
 * Users who CAN see it: VT_SVEB, VT_SJPO test users, all other jurisdictions
 * Users who CANNOT see it: VT_SJPO non-test users
 */
export function canUserSeeFilteredSublayer(
  accountId?: string,
  roleName?: string,
): boolean {
  const is_vt_sjpo =
    accountId &&
    accountId.toUpperCase() === VERMONT_SJPO_ACCOUNT_ID.toUpperCase();
  const is_vermont_test_user =
    roleName &&
    roleName.toLowerCase() === VERMONT_STATE_TEST_ROLENAME.toLowerCase();

  // If it's VT_SJPO and NOT a test user, they can't see it
  // Everyone else can see it
  return !(is_vt_sjpo && !is_vermont_test_user);
}
